"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const Portal_1 = __importDefault(require("@mui/material/Portal"));
const styled_components_1 = __importDefault(require("styled-components"));
const MobileUserFeedback_1 = __importDefault(require("../MobileUserFeedback"));
const DesktopUserFeedback_1 = __importDefault(require("../DesktopUserFeedback"));
const FeedbackContainer = styled_components_1.default.div `
  position: fixed;
  bottom: 32px;
  right: 0;
  z-index: 10;
`;
const UserFeedback = ({ isMobile, isModalVisible, ...rest }) => {
    if (isMobile) {
        return (0, jsx_runtime_1.jsx)(MobileUserFeedback_1.default, { isVisible: isModalVisible, ...rest });
    }
    return ((0, jsx_runtime_1.jsx)(Portal_1.default, { children: (0, jsx_runtime_1.jsx)(Slide_1.default, { direction: "left", in: isModalVisible, children: (0, jsx_runtime_1.jsx)(FeedbackContainer, { children: (0, jsx_runtime_1.jsx)(DesktopUserFeedback_1.default, { ...rest }) }) }) }));
};
exports.default = UserFeedback;
//# sourceMappingURL=index.js.map